import { getGridSummaryCount, renderGridSummarySum, renderGridSummarySumHL } from 'components/global/utils';
import { ReducedMaterialsGridData } from '@pages/reporting-pages/reduced-materials/types/ReducedMaterialsGridData';
import { ShowReasonColumn } from '@pages/reporting-pages/ShowReasonColumn';



interface GridSummaryProps<T> {
	data?: T[] | null,
	showReasonColumn: ShowReasonColumn,
}


const GridSummary = (props: GridSummaryProps<ReducedMaterialsGridData>) => {
	const { data, showReasonColumn } = props;

	return (
		<>
			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
				<p>{getGridSummaryCount(data)}</p>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			{(showReasonColumn === ShowReasonColumn.planning || showReasonColumn === ShowReasonColumn.planningAndExecution) &&
				<div className='app-grid-summary'>
				</div>}

			{(showReasonColumn === ShowReasonColumn.execution || showReasonColumn === ShowReasonColumn.planningAndExecution) &&
				<div className='app-grid-summary'>
				</div>}

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'orderOriginalCount')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'orderSentCount')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'orderDeliveredCount')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'orderOriginalVolume', 2)}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'orderSentVolume', 2)}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'orderDeliveredVolume', 2)}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'orderedMinusSentCount')}</p>
			</div>
			
			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'sentMinusDeliveredCount')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'orderedMinusSentVolume', 2)}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'sentMinusDeliveredVolume', 2)}</p>
			</div>
		</>
	)
}

export default GridSummary;